import { BritishColumbiaObstetricalFileClickableTextContext } from "@/Common/Models/UI/ClickableTextContext";
import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";
import { BritishColumbiaObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BritishColumbiaObstetricalFileForm";
import { CareProviderRole, CareProviderRoleHelper } from "@/Patient/Models/ObstetricalFile/BritishColumbia/Part1/CareProviderRole";

class BritishColumbiaObstetricalFileSection11 extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    private readonly commentsId = "Section11_CommentsFollowupId";

    public render(): JSX.Element {
        const section11 = this.props.form.Section11;

        return (
            <div className="section section-11">
                <div style={{ position: "relative" }}>
                    {this.renderField({
                        customLabel: this.renderTitle(11, "ObstetricalFile_CommentsFollowUpLabel", "vertically-centered"),
                        labelClassName: "margin-xs-bottom inline-flex-center flex-wrap flex-col-gap-xs",
                        labelSuffix: this.getLabelSuffix(this.getString("ObstetricalFile_InclDetailsFrom5To10Label"), "extra-info-label"),
                        field: this.controlRenderer.renderTextarea({
                            value: section11?.Comments,
                            onChange: value => this.props.mutateModelState(s => {
                                s.Section11.Comments = value;
                                this.autoFillCareProvider(s);
                            }),
                            id: this.commentsId,
                            clickableTextOptions: this.props.getClickableTextOptions(this.commentsId, BritishColumbiaObstetricalFileClickableTextContext.Section11_CommentsFollowup),
                            className: "comments-text-area",
                            maxLength: this.page1FieldLimits.Section11_CommentsFollowUp.MaxChars,
                            maxRows: this.page1FieldLimits.Section11_CommentsFollowUp.MaxRows
                        })
                    })}
                </div>
                <div className="inline-flex-center flex-wrap flex-gap-xs">
                    {this.renderInlineTextbox({
                        label: "CareProviderLabel",
                        value: section11.CareProvider,
                        onChange: value => this.props.mutateModelState(s => s.Section11.CareProvider = value),
                        className: "margin-sm-right flex-grow-1",
                        labelClassName: "bold text-nowrap",
                        maxLength: this.page1FieldLimits.Section11_CareProvider.MaxChars
                    })}
                    {this.controlRenderer.renderInlineRadio({
                        value: section11.CareProviderRole,
                        items: this.getCareProviderRoleOptions(),
                        onChange: value => this.props.mutateModelStateWithFormUpdate(s => s.Section11.CareProviderRole = value),
                        id: "Section11_CareProviderRole",
                        allowDeselect: true
                    })}
                </div>
            </div>
        );
    }

    protected autoFillCareProvider(state: BritishColumbiaObstetricalFileForm): void {
        if (!IsNullOrWhiteSpace(state.Section11.CareProvider))
            return;

        const careProvider = sessionStore.getCurrentEmployee();
        const careProviderRole = CareProviderRoleHelper.getCareProviderRoleByEmployee(careProvider);

        if (careProviderRole !== CareProviderRole.Other
            && !state.Metadata.CommentsAndFollowUpContributorContactIds.contains(careProvider.Model.Contact_id)
        ) {
            state.Metadata.CommentsAndFollowUpContributorContactIds.push(careProvider.Model.Contact_id);
            state.Section11.CareProvider = careProvider.Name;
            state.Section11.CareProviderRole = careProviderRole;
        }
    }
}

export { BritishColumbiaObstetricalFileSection11 };
